"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.RoleSchema = zod_1.default.enum([
    'CANDIDATE',
    'ADMIN',
    'CORPORATE_USER',
]);
